import axiosInstance from "../utils/axiosConfig";
import { IDashboardData } from "../interfaces/IDashboardData";

export async function getDashboardData(): Promise<IDashboardData> {
  try {
    const response = await axiosInstance.get(`/logs/dashboard`);
    
    if (!response?.data) {
      return {
        DashboardSummary: {
          CalculatedUsageToday: 0,
          EstimatedUsageToday: 0,
          FailedValidationsToday: 0,
          ErrorsToday: 0,
        },
        TodaysRuns: [],
      };
    }

    return {
      DashboardSummary: response.data.DashboardSummary,
      TodaysRuns: response.data.TodaysRuns,
    };
  } catch (error: any) {
    console.error("Error fetching dashboard data:", error.response?.data || error.message);

    return {
      DashboardSummary: {
        CalculatedUsageToday: 0,
        EstimatedUsageToday: 0,
        FailedValidationsToday: 0,
        ErrorsToday: 0,
      },
      TodaysRuns: [],
    };
  }
}
